import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import PDPGalleryRevampARButton from './PDPGalleryRevampARButton';

// shrink-0 + nowrap so a narrow viewport can't squeeze the pills into each
// other or wrap their labels onto a second line
const pillClass = 'items-center flex justify-center shrink-0 h-[30px] w-20 whitespace-nowrap rounded-full border border-solid text-xs transition-colors hover:cursor-pointer focus-visible:outline-brand';
const Divider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-[45px] w-px bg-gray-light6" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

// Measure / Closed-Open toggle / AR pills; each group renders independently
const PDPGalleryRevampControlsBar = t0 => {
  const $ = _c(25);
  const {
    isMeasureActive: t1,
    onToggleMeasure,
    showMeasure: t2,
    isMechanicalOpen: t3,
    toggleMechanicalOpen,
    isARActive: t4,
    onLaunchViewerAR: t5,
    onCloseViewerAR: t6
  } = t0;
  const isMeasureActive = t1 === undefined ? false : t1;
  const showMeasure = t2 === undefined ? false : t2;
  const isMechanicalOpen = t3 === undefined ? null : t3;
  const isARActive = t4 === undefined ? false : t4;
  const onLaunchViewerAR = t5 === undefined ? null : t5;
  const onCloseViewerAR = t6 === undefined ? null : t6;
  const showOpenCloseToggle = isMechanicalOpen != null;
  let t7;
  if ($[0] !== isMeasureActive || $[1] !== onToggleMeasure || $[2] !== showMeasure) {
    t7 = showMeasure && <button type="button" aria-pressed={isMeasureActive} data-xc="PDPGalleryRevampMeasureButton" onClick={onToggleMeasure} className={classNames(pillClass, {
      "bg-brand border-brand text-white": isMeasureActive,
      "bg-white border-brand text-gray-dark": !isMeasureActive
    })}>Measure</button>;
    $[0] = isMeasureActive;
    $[1] = onToggleMeasure;
    $[2] = showMeasure;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== showMeasure || $[5] !== showOpenCloseToggle) {
    t8 = showMeasure && showOpenCloseToggle && <Divider />;
    $[4] = showMeasure;
    $[5] = showOpenCloseToggle;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== isMechanicalOpen || $[8] !== showOpenCloseToggle || $[9] !== toggleMechanicalOpen) {
    t9 = showOpenCloseToggle && <div className="items-center flex gap-2"><span className="text-xs text-gray-dark">Closed</span><button type="button" role="switch" aria-checked={isMechanicalOpen} onClick={toggleMechanicalOpen} className={classNames("relative h-[30px] w-[57px] rounded-full transition-colors hover:cursor-pointer focus-visible:outline-brand", {
        "bg-brand": isMechanicalOpen,
        "bg-gray-light4": !isMechanicalOpen
      })}><span className={classNames("absolute left-0 top-[3px] h-6 w-6 rounded-full bg-white shadow transition-transform", {
          "translate-x-[30px]": isMechanicalOpen,
          "translate-x-[3px]": !isMechanicalOpen
        })} /><VisuallyHidden>{isMechanicalOpen ? "Show product closed" : "Show product open"}</VisuallyHidden></button><span className="text-xs text-gray-dark">Open</span></div>;
    $[7] = isMechanicalOpen;
    $[8] = showOpenCloseToggle;
    $[9] = toggleMechanicalOpen;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = !isARActive;
  let t11;
  if ($[11] !== isARActive || $[12] !== t10) {
    t11 = classNames(pillClass, {
      "bg-brand border-brand text-white": isARActive,
      "bg-white border-brand text-gray-dark": t10
    });
    $[11] = isARActive;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = showMeasure || showOpenCloseToggle;
  let t13;
  if ($[14] !== isARActive || $[15] !== onCloseViewerAR || $[16] !== onLaunchViewerAR || $[17] !== t11 || $[18] !== t12) {
    t13 = <PDPGalleryRevampARButton className={t11} isARActive={isARActive} showDivider={t12} onLaunchViewerAR={onLaunchViewerAR} onCloseViewerAR={onCloseViewerAR} />;
    $[14] = isARActive;
    $[15] = onCloseViewerAR;
    $[16] = onLaunchViewerAR;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t14 = <div className="flex items-center justify-center gap-4 min-h-[45px] mt-2 px-4 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" data-xc="PDPGalleryRevampControlsBar">{t7}{t8}{t9}{t13}</div>;
    $[20] = t13;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};
PDPGalleryRevampControlsBar.propTypes = {
  isMeasureActive: PropTypes.bool,
  onToggleMeasure: PropTypes.func,
  showMeasure: PropTypes.bool,
  isMechanicalOpen: PropTypes.bool,
  toggleMechanicalOpen: PropTypes.func,
  isARActive: PropTypes.bool,
  onLaunchViewerAR: PropTypes.func,
  onCloseViewerAR: PropTypes.func
};
export default PDPGalleryRevampControlsBar;